import paginateAction from '@utils/paginateAction';
import { templatesTypes } from '../constants';

export const defaultTemplateDetails = {
  count: 0,
  languages: [],
  'max-answered': '',
  'calculator-type': -1,
  subject: []
};

const defaultTemplateForm = {
  description: '',
  title: '',
  'test-type': 1,
  'cuttoff-marks': 0,
  details: defaultTemplateDetails,
  duration: 0,
  instructions: '',
  goal: {}
};

export const getTemplates =
  ({ key, resetWithoutEmpty = false }) =>
  (next) => ({
    type: templatesTypes.FETCH_TEMPLATES,
    endpoint: next,
    method: 'get',
    key,
    resetWithoutEmpty
  });

export const fetchTemplates = ({
  goalUID,
  duration,
  nextPage,
  forceReset = false
} = {}) => {
  const key = goalUID || 'allTemplates';
  let endpoint = 'v1/quizzes/templates/list_templates/?limit=6&offset=0';

  if (goalUID) {
    endpoint += `&goal_uid=${goalUID}`;
  }

  if (duration) {
    endpoint += `&duration=${duration}`;
  }

  return paginateAction(
    endpoint,
    getTemplates({ key, resetWithoutEmpty: forceReset }),
    'testSeriesTemplates',
    key,
    false,
    forceReset
  )(nextPage);
};

export const searchTemplate = ({
  goalUID,
  duration,
  query,
  nextPage,
  forceReset = false
} = {}) => {
  const key = `${query}${goalUID || ''}`;
  let endpoint = `v1/quizzes/templates/search_template/?title=${query}`;

  if (goalUID) {
    endpoint += `&goal_uid=${goalUID}`;
  }

  if (duration) {
    endpoint += `&duration=${duration}`;
  }

  return paginateAction(
    endpoint,
    getTemplates({ key, resetWithoutEmpty: forceReset }),
    'testSeriesTemplates',
    key,
    false,
    forceReset
  )(nextPage);
};

export const fetchTemplate = (id) => ({
  type: templatesTypes.FETCH_TEMPLATE,
  endpoint: `v1/quizzes/templates/search_template/?_id=${id}`,
  method: 'get'
});

export const deleteTemplate = (templateID) => ({
  type: templatesTypes.DELETE_TEMPLATE,
  endpoint: 'v1/quizzes/templates/delete_test_template/',
  method: 'post',
  data: {
    template_id: templateID
  }
});

export const updateOrCreateTemplate = (data, templateID) => ({
  type: templatesTypes.UPDATE_OR_CREATE_TEMPLATE,
  endpoint: 'v1/quizzes/templates/create_update_test_template/',
  method: 'post',
  data: {
    ...(templateID && { id: templateID }),
    template: data
  }
});

export const createTest = (data, uid) => ({
  type: templatesTypes.CREATE_TEST_FOR_TEMPLATE,
  endpoint: `v2/quizzes/me/edit/${uid}/`,
  method: 'post',
  data
});

export const resetEditForm = () => ({
  type: templatesTypes.RESET_TEMPLATE_FORM,
  data: defaultTemplateForm
});

export const updateTemplateSettings = (name, value) => ({
  type: templatesTypes.UPDATE_TEMPLATE_SETTINGS,
  name,
  value
});

export const updateTemplateDetails = (name, value, isAddType) => ({
  type: templatesTypes.UPDATE_TEMPLATE_DETAILS,
  name,
  value,
  isAddType
});

export const addOrUpdateTemplateSection = (value, position) => ({
  type: templatesTypes.ADD_OR_UPDATE_TEMPLATE_SECTION,
  value,
  isAddType: position === null,
  position
});

export const updateTemplateEvaluationCriteria = (position, value) => ({
  type: templatesTypes.UPDATE_TEMPLATE_EVALUATION_CRITERIA,
  position,
  value
});

export const updateTemplateInstructions = (value) => ({
  type: templatesTypes.UPDATE_TEMPLATE_INSTRUCTIONS,
  value
});

export const setTemplateErrors = (errors) => ({
  type: templatesTypes.SET_TEMPLATE_ERRORS,
  errors
});

export const fetchTemplateDetails = (templateUID) => ({
  type: templatesTypes.FETCH_TEST_TEMPLATE_DETAILS,
  endpoint: `v1/quizzes/templates/get_template_detail/?id=${templateUID}`,
  method: 'get',
  templateUID
});

export const createQuizInTemplate = (data) => ({
  type: templatesTypes.CREATE_QUIZ_IN_TEMPLATE,
  endpoint: 'v2/quizzes/me/create/',
  method: 'post',
  data
});

export const editQuizInTemplate = (data, uid) => ({
  type: templatesTypes.EDIT_QUIZ_IN_TEMPLATE,
  endpoint: `v2/quizzes/me/edit_template/${uid}/`,
  method: 'post',
  data
});

export const fetchTestState = (templateUID) => ({
  type: templatesTypes.FETCH_TEST_STATE,
  endpoint: `v1/uplus/course_template/quiz_info/?id=${templateUID}`,
  method: 'get'
});

export const clearTemplateField = (ids = [], isContentOp) => ({
  type: templatesTypes.CLEAR_TEMPLATE_FIELDS,
  ids,
  isContentOp
});

export const updateEducatorSlides = (data, uid) => ({
  type: templatesTypes.UPDATE_EDUCATOR_SLIDES,
  data,
  uid
});
